import React from 'react'

import './index.css'

interface Props {
   className?: string
   fill?: string
   height?: number
   width?: number
}

const GradientRingLoader = (props: Props): React.ReactElement => {
   const { height = 60, width = 60, ...rest } = props

   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         viewBox='0 0 60 60'
         height={height}
         width={width}
         {...rest}
         fill={'none'}
         stroke={'none'}
      >
         <g className='spinner'>
            <rect
               x='2'
               y='2'
               width='56'
               height='56'
               rx='28'
               stroke='url(#paint0_linear_5076_10073)'
               strokeWidth='4'
               fill='none'
            />
         </g>
         <defs>
            <linearGradient
               id='paint0_linear_5076_10073'
               x1='30'
               y1='4'
               x2='30'
               y2='56'
               gradientUnits='userSpaceOnUse'
            >
               <stop stopColor='#A9D7FD' />
               <stop offset='1' stopColor='#085CCA' />
            </linearGradient>
         </defs>
      </svg>
   )
}

export default GradientRingLoader
